module.exports = __webpack_public_path__ + "img/1P40.35b22c0e.png";